<template>

    <section class="carrinho">

        <CheckAcesso />

        <section class="main-minha_conta">

            <div class="container">
                <div class="row">
                    <!-- Sidenav -->
                    <div class="col-lg-2" style="background-color: #cccccc;">
                        <ul class="lista-sidebar_links" style="list-style-type: none;padding:10px;">
                            <li style="border-bottom: 1px solid #f9f9f9 ;padding:10px;"><router-link to="/meusDados" class="texto">Meus Dados</router-link></li>
                            <li style="border-bottom: 1px solid #f9f9f9 ;padding:10px;"><router-link to="/meusPedidos" class="texto">Meus Pedidos</router-link></li>
                            <li style="border-bottom: 1px solid #f9f9f9 ;padding:10px;"><router-link to="/meusArquivos" class="texto">Arquivos</router-link></li>
                            <li style="border-bottom: 1px solid #f9f9f9 ;padding:10px;"><router-link to="/meusGaleriaFotos" class="texto">Galeria de Fotos</router-link></li>
                            <li style="border-bottom: 1px solid #f9f9f9 ;padding:10px;"><router-link to="/meusVideos" class="texto">V&iacute;deos</router-link></li>
                        </ul>
                    </div>
                    <!-- Main -->
                    <div class="col-lg-10 col-xl-9 offset-xl-1 mt-5 mt-lg-0">
                        <h3 class="titulo-principal text-center mb-4">Minha Conta</h3>
                        <h6 class="subtitulo h5 mb-4">Meus Arquivos</h6>
                        <!-- Lista de arquivos -->
                        <div class="row">
                            <div class="col">
                                <div v-for="arquivo in Arquivos" :key="arquivo.arquivosClienteId" class="col-lg- col-xl-3 col-6" style="text-align:center;">
                                    <a :href="$Url + arquivo.arquivo.urlArquivo" target="_blank">
                                        <div style="padding-bottom:10px;">
                                            <img src="/imagens/pdfimg.jpg" style="width:100px" />
                                        </div>
                                        <p>
                                            {{ arquivo.arquivo.nomeArquivo }}
                                        </p>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>

        </section>

    </section>

</template>

<script>

    import CheckAcesso from '@/components/site/shared/CheckAcesso.vue'
    import moment from 'moment';

    export default {
        components: {
            CheckAcesso,
        },
        data() {
            return {
                ClienteId: 0,
                PedidoId: this.$route.params.id,
                Arquivos: [],
                NomeArquivo:'teste',
            }
        },
        methods: {
            FormataData(value) {
                return moment(value).format('DD/MM/YYYY')
            },
        },
        created() {

            let usuarioTmp = JSON.parse(this.$cookie.get(this.$UsuarioCookie));
            if (usuarioTmp != null) {
                this.ClienteId = parseInt(usuarioTmp.usuarioId, 10)
            }

            this.$http
                .get(this.$apiUrl + "/ArquivosClientes")
                .then((res) => res.json())
                .then((retornoAPI) => {
                    this.Arquivos = retornoAPI.filter(x => x.arquivo.visivel && x.cliente.clienteId == this.ClienteId);
                    console.log(this.ClienteId)
                    console.log(this.Arquivos)
                });

        }
    }

</script>

<style scoped>

    @import '/css_cart/carrinho.css';
    @import '/css_cart/minha_conta.css';
    @import '/css/modais.css';
</style>